import { ViewStyle } from "react-native";

import { ClassGroupType } from "../../Style.types";

export interface IDimensionsClassGroup {
  w100: ViewStyle;
  w75: ViewStyle;
  w66: ViewStyle;
  w50: ViewStyle;
  w33: ViewStyle;
  w25: ViewStyle;
  wAuto: ViewStyle;
  h100: ViewStyle;
  h75: ViewStyle;
  h66: ViewStyle;
  h50: ViewStyle;
  h33: ViewStyle;
  h25: ViewStyle;
  hAuto: ViewStyle;
  w100abs: ViewStyle;
  w100top: ViewStyle;
  w100bottom: ViewStyle;
}
export const DimensionsClassGroup: ClassGroupType<IDimensionsClassGroup> = {
  w100: { width: "100%" },
  w75: { width: "75%" },
  w66: { width: "66%" },
  w50: { width: "50%" },
  w33: { width: "33%" },
  w25: { width: "25%" },
  wAuto: { width: "auto" },
  h100: { height: "100%" },
  h75: { height: "75%" },
  h66: { height: "66%" },
  h50: { height: "50%" },
  h33: { height: "33%" },
  h25: { height: "25%" },
  hAuto: { height: "auto" },
  w100abs: {
    left: 0,
    right: 0,
  },
  w100top: {
    top: 0,
    left: 0,
    right: 0
  },
  w100bottom: {
    bottom: 0,
    left: 0,
    right: 0
  }
};
